import { ofType } from 'redux-observable';
import { map, mergeMap, flatMap } from 'rxjs/operators';
import { from } from 'rxjs';

import { TransformResponse } from './transform';

import {
    SETSELECTED,
    NO_CHANGE,
    RESET,
    SET as patientSET,
    SETSELECTED_ATHENA,
    SETSELECTED_CERNER,
    SETSELECTED_NEXTGEN,
    SETSELECTED_MEDITECH
} from 'one-state-subject/src/types';

import {
    addAction,
    disableAddAction,
    setAction,
    reinitAction,
    setStatusAction
} from 'one-state-notes-history';

import {
    setAction as setSkeletonAction
} from 'one-state-skeleton';


import {
    addAction as errorAddAction
} from 'one-state-error/src/actions';

import {
    ErrorObject
} from 'one-state-error/src/errorobject';

import {format} from 'one-util-date';

import { Disposition } from 'one-model-local';

export const enum Types {
    NOTES_HISTORY__ADD = "notes-history--add",
    STORE_DISPOSITION_CODE = "store-disposition-code"
};

const pushToSkeleton = (payload: any) => setSkeletonAction(payload);
const pushToDisposition = (payload: any) => ({ type: Types.STORE_DISPOSITION_CODE, payload });

/**
 * This Fuction will fetch the data of notes history epic
 * from backend api and returns the response and calls
 * subsequent redux action
 * @param context contains the settings etc..
 */

export const fetchNotesHistoryEpic = (context: any) => (
    (action$: any, state$: any) => {
        const errorTime = format(new Date(), 'LT');
        const errorDate = format(new Date(), 'LL');
        const { log, server, agentId, agentLoginName, teamName, interactionApi, settings: {
            servers,
            epicendpoints: { apitoken },
            commonendpoints: { getnotes },
            compatible: { consolidated_api_invocation, contact_center_type },
        } } = context;
        const { locations = [] } = servers;
        return action$.pipe(
            consolidated_api_invocation ? ofType(NO_CHANGE) : ofType(SETSELECTED, SETSELECTED_ATHENA, SETSELECTED_CERNER,SETSELECTED_NEXTGEN,SETSELECTED_MEDITECH),
           
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contains the Referrals Response
                 */
                let dataresponse: any = action.payload;
                if (contact_center_type && contact_center_type === 'five9') {
                    let five9AgentId = sessionStorage.getItem("five9_userid");
                    interactionApi.executeRestApi({ path: `/appsvcs/rs/svc/agents/${five9AgentId}`, method: 'GET', payload: null })
                        .then(function (result: any) {
                            // resolve handler
                            const { response } = result
                            const data = JSON.parse(response.replace('/', ''))
                            sessionStorage.setItem("agentName", data.fullName);
                        }, function (error: any) {
                            // reject handler
                            log.debug('Call variables error ', error);
                        }
                    );
                }

                const getRequest = (datares: any) => {
                    if (datares?.id) {
                        let headers = new Headers();
                        headers.set('Authorization', 'Basic ' + apitoken?.token);
                        let response;
                        
                        response = server.get({
                            path: `${getnotes}?patient_id=${datares.id}`,
                            headers: headers
                        })
                            .then((responsefound: any) => responsefound)
                            .catch((responseresult: any) => {
                                let errorbuild: ErrorObject = {
                                    source: "NotesHistory",
                                    type: "error",
                                    status: responseresult?.status,
                                    erroritems: responseresult?.errors ?? [],
                                    error_date: errorDate,
                                    error_time: errorTime
                                };
                                return errorbuild;
                            })
                        return from(response)
                    } else {
                        return from([]);
                    }
                }
                
                return getRequest(dataresponse).
                    pipe(
                        map((response: any) => TransformResponse(response, context))).
                    pipe(
                        flatMap(response => {
                            const actions: any = [
                                setAction(response)];
                            if (response.error) {
                                actions.push(errorAddAction(response.error));
                                let disp: Disposition = { value: '2024' }
                                if (contact_center_type && contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("five9_userid");
                                    let skillName = sessionStorage.getItem("skillName");
                                    disp.meta00 = agentIdValue;
                                    disp.meta01 = skillName;
                                    disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                } else {
                                    disp.meta00 = agentId;
                                    disp.meta01 = teamName;
                                    disp.dial_list_uid = state$.value.choosecaller?.callId;
                                }
                                disp.meta02 = response.error.status;
                                disp.meta03 = dataresponse.id;
                                disp.meta04 = response.error?.display_text;
                                disp.meta05 = 'Failed to fetch the Agent Notes';
                                actions.push(pushToDisposition(disp));
                            } else {
                                let disp: Disposition = { value: '2023' }
                                if (contact_center_type && contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("five9_userid");
                                    let skillName = sessionStorage.getItem("skillName");
                                    disp.meta00 = agentIdValue;
                                    disp.meta01 = skillName;
                                    disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                } else {
                                    disp.meta00 = agentId;
                                    disp.meta01 = teamName;
                                    disp.dial_list_uid = state$.value.choosecaller?.callId;
                                }
                                disp.meta02 = 'Agent notes fetched successfully';
                                actions.push(pushToDisposition(disp));
                            }
                            
                            return actions;
                        })
                    )
            })
        )
    }
);

export const addNotesHistoryEpic = (context: any) => (
    (action$: any, state$: any) => {
        const errorTime = format(new Date(), 'LT');
        const errorDate = format(new Date(), 'LL');
        const { log, server, agentId, agentLoginName, teamName, settings: {
            servers,
            epicendpoints: { apitoken },
            commonendpoints: { addnotes },
            uisettings: {
                agent_notes: { eteToSave }
            },
            compatible: { contact_center_type },
        } } = context;
        return action$.pipe(
            ofType(Types.NOTES_HISTORY__ADD),
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contains the Referrals Response
                 */
                let dataresponse: any = action.payload;
                let agentIdValue; // agent name
                
                if (contact_center_type && (contact_center_type === 'five9' || contact_center_type === 'genesys' || contact_center_type === 'inContact')) {
                    agentIdValue = sessionStorage.getItem("agentName");
                } else if (contact_center_type && contact_center_type === 'finesse') {
                    agentIdValue = agentLoginName;
                } else if (contact_center_type && contact_center_type === 'twilio') {
                    agentIdValue = sessionStorage.getItem("twilio_userid");
                } else if (contact_center_type && contact_center_type === 'wxcc') {
                    let wxccuser = sessionStorage.getItem("wxcc_userid")
                    agentIdValue = wxccuser;
                } 
                else if (contact_center_type && contact_center_type === 'ringcentral') {
                    agentIdValue = sessionStorage.getItem("ringcentral_agentName");
                } 
                else if (contact_center_type && contact_center_type === 'intermedia') {
                    agentIdValue = sessionStorage.getItem("intermedia_uid");
                }
                else if (contact_center_type && contact_center_type === 'glia') {
                    agentIdValue = sessionStorage.getItem("GliaUser");
                } else {
                    agentIdValue = agentId;
                }

                const getRequest = (datares: any, agentIdValue: any) => {
                    if (datares?.patientId) {
                        let headers = new Headers();
                        headers.set('Authorization', 'Basic ' + apitoken?.token);
                        let response;
                        let data = {};
                        if (eteToSave.epic) {
                            data = {
                                patient_id: datares.patientId,
                                agent_id: agentIdValue,
                                notes: datares.note,
                                isEpic: true,
                                epic: {
                                    epic_userid: state$.value.epicuserid.agentuserid,
                                    patient_MRN: state$.value.subjectstore.selected.prescriptionMRNData,
                                    first_name: state$.value.subjectstore.selected.firstname,
                                    last_name: state$.value.subjectstore.selected.lastname,
                                    middle_name_initial: state$.value.subjectstore.selected.middlename,
                                    dob: state$.value.subjectstore.selected.dob,
                                    gender: state$.value.subjectstore.selected.gender
                                }
                            };
                        } else {
                            data = {
                                patient_id: datares.patientId,
                                agent_id: agentIdValue,
                                notes: datares.note,
                                disposition:datares.disposition,
                                policynum:datares.policynum
                            };
                        }

                        response = server.post({
                            path: addnotes,
                            headers: headers,
                            data: data
                        })
                            .then((responsefound: any) => responsefound)
                            .catch((responseresult: any) => {
                                let errorbuild: ErrorObject = {
                                    source: "NotesHistory",
                                    type: "error",
                                    status: responseresult?.status,
                                    erroritems: responseresult?.errors ?? [],
                                    error_date: errorDate,
                                    error_time: errorTime
                                };
                                return errorbuild;
                            })
                        return from(response)
                    } else {
                        return from([]);
                    }
                }

                if (!agentIdValue) {
                    const actions: any = [];
                    // dispatch action to disable add notes
                    actions.push(disableAddAction(true));
                    return from(actions);
                }
                return getRequest(dataresponse, agentIdValue).
                    pipe(
                        map((response: any) => TransformResponse(response, context))).
                    pipe(
                        flatMap((response: any) => {
                            const actions: any = [];
                            actions.push(addAction(response));
                            if (response.error) {
                                actions.push(errorAddAction(response.error));
                                let disp: Disposition = { value: '2026' }
                                if (contact_center_type && contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("five9_userid");
                                    let skillName = sessionStorage.getItem("skillName");
                                    disp.meta00 = agentIdValue;
                                    disp.meta01 = skillName;
                                    disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                } else {
                                    disp.meta00 = agentId;
                                    disp.meta01 = teamName;
                                    disp.dial_list_uid = state$.value.choosecaller?.callId;
                                }
                                disp.meta02 = response.error.status;
                                disp.meta03 = dataresponse.patientId;
                                disp.meta04 = response.error?.display_text;
                                disp.meta05 = 'Failed to update the Agent Notes';
                                actions.push(pushToDisposition(disp));
                                actions.push(setStatusAction(400));
                            } else {
                                let disp: Disposition = { value: '2025' }
                                if (contact_center_type && contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("five9_userid");
                                    let skillName = sessionStorage.getItem("skillName");
                                    disp.meta00 = agentIdValue;
                                    disp.meta01 = skillName;
                                    disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                } else {
                                    disp.meta00 = agentId;
                                    disp.meta01 = teamName;
                                    disp.dial_list_uid = state$.value.choosecaller?.callId;
                                }
                                disp.meta02 = 'Updated the Agent Notes Successfully';
                                disp.meta03 = dataresponse?.id;
                                actions.push(pushToDisposition(disp));
                                actions.push(setStatusAction(200));
                            }
                            
                            return actions;
                        })
                    )
            })
        )
    }
);

/**
 * This Fuction will clear data of notes history epic
 * subsequent redux action
 * @param context contains the settings,logger etc..
 */
export const clearNotesEpic = (context: any) => (
    (action$: any) => {
        const { log } = context;
        return action$.pipe(
            ofType(patientSET, RESET),
            map(action => reinitAction())
        )
    }
);
